import(/* webpackMode: "eager" */ "/actual-project/app/globals.css");
import(/* webpackMode: "eager" */ "/actual-project/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/actual-project/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/actual-project/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/actual-project/components/ui/tooltip.tsx")